import CadastralService from '@/services/CadastralService.js';
import { shuffleArray } from '@/utils';

const files = {
  namespaced: true,

  state: {
    filteredCities: [],
    // estado que almacena las bases catastrales disponibles en ARkandha
    cadastralBases: [],
    // eatdo que almacena la busqueda por poligonos
    cadastralBasesSearchResult: null,
    // estado que almacena los resultados de la colindancia
    cadastralAdjacencyResult: null,
    // eatdo con el npn del folio al que se le esta haciendo el analisis de colindancia
    currentAdjacencyEstate: '',
    // esatdo con la base catastral usada en analisis de colindancia
    currentAdjacencyBase: null,
    // color para el predio analizado (vista colindantes)
    redColor: '#F44336',
    // color para el predio colindantes (vista colindantes)
    greenColor: '#4CAF50',
    // color para el predio colindantes sin folio (vista colindantes)
    greyColor: '#9E9E9E',
    // propiedad compuatada con el geojson de los cruces
    estatesAdjoiningGeojson: null,
    // estado con los colores para inicializar
    adjoiningColors: [
      '#E91E63', // pink
      '#9C27B0', // purple
      '#673AB7', // deep-purple
      '#3F51B5', // indigo
      '#2196F3', // blue
      '#00BCD4', // cyan
      '#009688', // teal
      '#4CAF50', // green
      '#8BC34A', // light-green
      '#CDDC39', // lime
      '#FFEB3B', // yellow
      '#FFC107', // amber
      '#FF9800', // orange
      '#FF5722', // deep-orange
      '#795548', // brown
      '#607D8B', // blue-grey
    ],
    // Listado estados de dominios catastrales
    economicDestinations: [],
    constructionUses: [],
    typologyUses: [],
    physicalZones: [],
    economicZones: [],
  },

  mutations: {
    CLEAR_CITIES(state) {
      state.filteredCities = [];
    },
    CHANGE_VALUE(state, { value, varName }) {
      /**
       * Mutación para cambiar el valor de un estado del store
       *
       * @param {Object} state con los elementos del estado del store
       * @param {Object}  payload los datos de la mutación
       * @returns {} No retorna nada
       * @example
       * $store.commit('cadastral/CHANGE_VALUE', {
       *  value: '<state_name>',
       *  varName: '<state_value>'
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      state[varName] = value;
    },
    CLEAR_ADJOINING_GEOJSON(state,) {
      /**
       * Mutación para cambiar el valor de un estado del store
       *
       * @param {Object} state con los elementos del estado del store
       * @param {Object}  payload los datos de la mutación
       * @returns {} No retorna nada
       * @example
       * $store.commit('cadastral/CHANGE_VALUE', {
       *  value: '<state_name>',
       *  varName: '<state_value>'
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      state.cadastralAdjacencyResult.geojson = null;
    },
    UPDATE_GEOJSON_COLOR(state, { npn, color }) {
      /**
       * Mutación para actualizar el color de un predio del
       * analisis de colindancia
       *
       * @param {Object} state con los elementos del estado del store
       * @param {Object}  payload los datos de la mutación
       * @returns {} No retorna nada
       * @example
       * $store.commit('cadastral/UPDATE_GEOJSON_COLOR', {
       *  npn: '156380000000000020151000000000',
       *  color: '#ffffff'
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      state.estatesAdjoiningGeojson.features.map((x) => {
        if (x.properties.codigo === npn){
          x.properties.color = color;
        }
        return x;
      });
      // acualizar color datos alfanumericos
      state.cadastralAdjacencyResult.adjacencies.map((x) => {
        if (x.codigo === npn){
          x.color = color;
        }
        return x;
      });
    },
    UPDATE_ADJOINING_DATA(state, { npn, data }) {
      /**
       * Mutación para actualizar el color de un predio del
       * analisis de colindancia
       *
       * @param {Object} state con los elementos del estado del store
       * @param {Object}  payload los datos de la mutación
       * @returns {} No retorna nada
       * @example
       * $store.commit('cadastral/UPDATE_GEOJSON_COLOR', {
       *  npn: '156380000000000020151000000000',
       *  color: '#ffffff'
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      state.cadastralAdjacencyResult.adjacencies.map((x) => {
        if (x.codigo === npn){
          x.cabida = data.cabida;
          x.color = data.color;
          x.complementacion = data.complementacion;
          x.folio_id = data.folio_id;
          x.url_archivo = data.url_archivo;
        }
        return x;
      });
    }
  },

  actions: {
    async getCities({ commit, state }, search) {
      /**
       * Accion para obtener las ciudades por un criterio de busqueda
       *
       * @param {Object} context datos del modulo
       * @param {String} search criterio de busqueda
       * @example
       * $store.dispatch('cadastral/getCities', '<city_name>')
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      try {
        const token = localStorage.getItem('token');
        const response = await CadastralService.getCities(search, token);
        if (response) {
          state.filteredCities = response.data;
        }
      } catch (error) {
          commit('ui/SHOW_ALERT',{
            alertMessage: `Ocurrio un error al conseguir las ciudades
              (${error.response.status} - ${error.response.data.detail})`,
            alertType: 'error'
          }, {root: true});
      }
    },
    async getCadastralBases({ commit, state }) {
      /**
       * Accion para obtener las bases catastrales disponibles en ARkandha
       *
       * @param {Object} context datos del modulo
       * @param {String} search criterio de busqueda
       * @example
       * $store.dispatch('cadastral/getCadastralBases')
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      try {
        const token = localStorage.getItem('token');
        const response = await CadastralService.getCadastralBases( token);
        if (response) {
          state.cadastralBases = response.data;
        }
      } catch (error) {
          commit('ui/SHOW_ALERT',{
            alertMessage: `Ocurrio un error al conseguir las bases catastrales
              (${error.response.status} - ${error.response.data.detail})`,
            alertType: 'error'
          }, {root: true});
      }
    },
    async cadastralBasesSearch({ commit, state }, { npn }) {
      /**
       * Accion para obtener los poligonos de un NPN
       *
       * @param {Object} context datos del modulo
       * @param {String} payload criterio de busqueda
       * @example
       * $store.dispatch('cadastral/cadastralBasesSearch', {
       *   npn: '154070000000000100030000000000'
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      const token = localStorage.getItem('token');
      try {
          const response = await CadastralService.cadastralBasesSearch(npn, token);
          if (response) {
            const data = response.data;
            state.cadastralBasesSearchResult = data;
            // contar el nuemro de bases en las que se encontro el poligono
            const countBases = data.filter((x) => x.geojson !== null).length;
            if (countBases == 0) {
              commit('ui/SHOW_ALERT',{
                alertMessage: 'No hubo resultados que coincidieran con los criterios de la busqueda',
                alertType: 'warning'
              }, {root: true});
            } else {
              commit('ui/SHOW_ALERT',{
                alertMessage: `El NPN fue encontrado en <b>${countBases}</b> bases catastrales`,
                alertType: 'success'
              }, {root: true});
            }
          }
      } catch (error) {
        commit('ui/SHOW_ALERT',{
          alertMessage: `Ocurrio un error en la consulta de la información
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
      }
    },
    async cadastralAdjacencySearch({ commit, state }, { npn, base, buffer }) {
      /**
       * Accion para obtener los poligonos colindates de un NPN
       *
       * @param {Object} context datos del modulo
       * @param {String} payload criterio de busqueda
       * @example
       * $store.dispatch('cadastral/cadastralAdjacencySearch', {
       *   npn: '154070000000000100030000000000',
       *   base: 'predios_totales_2023_03',
       *   buffer: 20
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      // setear el predio objeto de estudio
      state.currentAdjacencyEstate = npn;
      state.currentAdjacencyBase = base;
      const token = localStorage.getItem('token');
      try {
          const response = await CadastralService.cadastralAdjacencySearch(npn, base, buffer, token);
          // state.cadastralAdjacencyResult = response;
          if (response) {
            state.cadastralAdjacencyResult = response.data;
            state.estatesAdjoiningGeojson = JSON.parse(JSON.stringify(response.data.geojson));
            // contar el numero de colindancias del predio
            const countMatches = state.cadastralAdjacencyResult.adjacencies.filter((x) => x.codigo !== state.currentAdjacencyEstate).length;
            if (countMatches == 0) {
              commit('ui/SHOW_ALERT',{
                alertMessage: 'No se encontraron predios colindantes para el criterio de busqueda',
                alertType: 'warning'
              }, {root: true});
            } else {
              commit('ui/SHOW_ALERT',{
                alertMessage: `El NPN tiene <b>${countMatches}</b> predio(s) colindantes`,
                alertType: 'success'
              }, {root: true});
            }
          }
      } catch (error) {
        commit('ui/SHOW_ALERT',{
          alertMessage: `Ocurrio un error en la consulta de la información
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
      }
    },
    async syncAdjoiningFolio({ commit, state }, { fmi, codigo, codigo_ant}) {
      /**
       * Accion para actualizar un predio d ela vista de colindancia
       *
       * @param {Object} context datos del modulo
       * @param {String} fmi folio de matricula inmobiliaria
       * @example
       * $store.dispatch('cadastral/syncAdjoiningFolio', '132-1')
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      const token = localStorage.getItem('token');
      // establecer el color con el que debe ser marcado el folio
      let color = state.greenColor;
      if ([codigo, codigo_ant].includes(state.currentAdjacencyEstate)) {
        color = state.redColor;
      }
      try {
        const response = await CadastralService.syncAdjoiningFolio(
          fmi, color, token);
        if (response.data) {
          commit('ui/SHOW_ALERT',{
            alertMessage: 'Folio Sincronizado exitosamente',
            alertType: 'success'
          }, {root: true});
          return response.data;
        }
        return null;
      } catch (error) {
        commit('ui/SHOW_ALERT',{
          alertMessage: `Ocurrio un error al sincronizar el folio
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
        return null;
      }
    },
    async fillColorEstates({ commit, state }) {
      /**
       * Accion para rellenar de forma automatica el color de los predios
       *
       * @param {Object} context datos del modulo
       * @example
       * $store.dispatch('cadastral/fillColorEstates')
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      const colorsArray = shuffleArray(state.adjoiningColors);
      const adjacencies = state.cadastralAdjacencyResult.adjacencies;
      for (let index = 0; index < adjacencies.length; index++) {
        const element = adjacencies[index];
        if (element.codigo !== null && element.codigo !== '') {
          if (state.currentAdjacencyEstate === element.codigo
            || state.currentAdjacencyEstate === element.codigo_ant ) continue;
          let colorIndex = index;
          if ((index + 1) > colorsArray.length) {
            colorIndex = ((index + 1) % colorsArray.length) - 1;
          }
          const color = colorsArray[colorIndex];
          commit('UPDATE_GEOJSON_COLOR', {
            npn: element.codigo,
            color
          })
        }
      }
    },
    async getCadastralDomains({ commit, state }) {
      /**
       * Accion para obtener los dominios catastrales
       *
       * @param {Object} context datos del modulo
       * @example
       * $store.dispatch('cadastral/getCadastralDomains')
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      const token = localStorage.getItem('token');
      try {
        const response = await CadastralService.getCadastralDomains(token);
        if (response.data) {
          state.economicDestinations = response.data.economic_destinations;
          state.constructionUses = response.data.construction_uses;
          state.typologyUses = response.data.typology_uses;
          state.physicalZones = response.data.physical_zones;
          state.economicZones = response.data.economic_zones;
          return { obtained: true };
        }
        return null;
      } catch (error) {
        commit('ui/SHOW_ALERT',{
          alertMessage: `Ocurrio un error al obtener los dominios catastrales
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
        return { obtained: false };
      }
    },
    async adjoiningReport({ commit, state }, imageData) {
      /**
       * Accion para obtener los dominios catastrales
       *
       * @param {Object} context datos del modulo
       * @param {Strin} imageData datos de la imagen
       * @example
       * $store.dispatch('cadastral/getCadastralDomains')
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      const token = localStorage.getItem('token');
      const data = JSON.stringify({
        info: state.cadastralAdjacencyResult.adjacencies,
        image: imageData,
        target_estate: state.currentAdjacencyEstate,
        cadastral_base: state.currentAdjacencyBase
      })
      try {
        const response = await CadastralService.adjoiningReport(data, token);
        console.log(response);
        if (response.data) {
          commit('ui/SHOW_ALERT',{
            alertMessage: 'Reporte generado exitosamente',
            alertType: 'success'
          }, {root: true});

          return { obtained: true, report: response.data.file_content };
        }
        return null;
      } catch (error) {
        commit('ui/SHOW_ALERT',{
          alertMessage: `Ocurrio un error al generar el reporte
            (${error.response.status} - ${error.response.data.detail})`,
          alertType: 'error'
        }, {root: true});
        return { obtained: false };
      }
    },
  },

  getters: {
    processedFiles(state) {
      return state.fileList.filter((x) => x.processed === true);
    },
    rawFiles(state) {
      return state.fileList.filter((x) => x.processed === false);
    },
    cadastralBaseInfo: (state) => (base) => {
      return state.cadastralBasesSearchResult.filter((x) => x.name === base)[0];
    }
  }
};
  
export default files;
